// Mock data for Aaryan Simlai's Portfolio

export const personalInfo = {
  name: "Aaryan Simlai",
  tagline: "Building the Future with AI",
  subtitle: "AI Developer | Founder of SIMLAI | Vision-Driven Builder",
  about: "A tech-driven entrepreneur focused on AI, innovation, and building futuristic systems. Passionate about pushing the boundaries of what's possible when human creativity meets artificial intelligence.",
  email: "aaryansimlai06@gmail.com",
  linkedin: "https://www.linkedin.com/in/simlaiaaryan/",
  stats: [
    { label: "Projects Built", value: 15 },
    { label: "Technologies", value: 24 },
    { label: "Vision Areas", value: 3 }
  ]
};

export const projects = [
  {
    id: 1,
    title: "SIMLAI",
    fullName: "Systema International for Machine Learning and AI",
    description: "My main identity and AI ecosystem brand. Not just a portfolio - it's an AI lab, personal brand, and future company rolled into one. Building AI systems and showcasing cutting-edge work.",
    tech: ["AI Systems", "Machine Learning", "Research", "Innovation"],
    category: "Brand Ecosystem",
    status: "Active",
    link: "#"
  },
  {
    id: 2,
    title: "Vision Bot",
    fullName: "AI Voice Agent System",
    description: "An intelligent AI voice agent built to pitch businesses. Handles restaurant reservations, waitlists, menu queries, and POS integrations. A demo product showcasing real-world AI capability for client conversion.",
    tech: ["Voice AI", "NLP", "API Integration", "POS Systems"],
    category: "AI Agent",
    status: "Demo Ready",
    link: "#"
  },
  {
    id: 3,
    title: "FusionLink",
    fullName: "Human-AI Synchronization System",
    description: "The most advanced concept: 100% synchronization between human brain and AI. Inspired by the movie Atlas, where AI understands your thoughts, preferences, and intent - becoming an extension of your mind.",
    tech: ["Neural Interface", "Agentic AI", "Deep Learning", "HCI"],
    category: "Future Vision",
    status: "In Development",
    link: "#"
  }
];

export const skills = [
  {
    category: "AI & Machine Learning",
    items: [
      { name: "Agentic AI" },
      { name: "Machine Learning" },
      { name: "Natural Language Processing" },
      { name: "Neural Networks" }
    ]
  },
  {
    category: "Development",
    items: [
      { name: "Python" },
      { name: "JavaScript / React" },
      { name: "FastAPI" },
      { name: "System Design" }
    ]
  },
  {
    category: "Tools & Technologies",
    items: [
      { name: "Git" },
      { name: "Firebase" },
      { name: "Figma" },
      { name: "Node.js" }
    ]
  },
  {
    category: "Creative Intelligence",
    items: [
      { name: "Psychology" },
      { name: "Story Building" },
      { name: "Narrative Design" },
      { name: "Systems Thinking" },
      { name: "World Building" },
      { name: "Philosophical Thinking" }
    ]
  }
];
export const achievements = [
  {
    title: "WoxHack Winner",
    organization: "Woxsen University",
    description: "3rd Place Winner at WoxHack - Demonstrating innovative AI solutions",
    year: "2024"
  },
  {
    title: "Certified Technical Writer",
    organization: "Professional Certification",
    description: "Specialized in technical documentation and AI system architecture",
    year: "2024"
  },
  {
    title: "Certified Prompt Engineer",
    organization: "Professional Certification",
    description: "Expert in crafting effective prompts for LLMs and AI systems",
    year: "2024"
  }
];

export const visionTimeline = [
  {
    phase: "Present",
    title: "Building AI-Powered Systems",
    description: "Creating intelligent automation and AI agents that solve real-world problems"
  },
  {
    phase: "Near Future",
    title: "Scaling SIMLAI Ecosystem",
    description: "Expanding AI solutions for businesses and establishing SIMLAI as a leading AI innovation lab"
  },
  {
    phase: "Vision",
    title: "Human-AI Synchronization",
    description: "Pioneering seamless integration between human intelligence and AI, where technology becomes an extension of thought"
  }
];

export const techStack = [
  { name: "Python", icon: "code" },
  { name: "TensorFlow", icon: "brain" },
  { name: "PyTorch", icon: "cpu" },
  { name: "React", icon: "layout" },
  { name: "FastAPI", icon: "zap" },
  { name: "LangChain", icon: "link" },
  { name: "OpenAI", icon: "sparkles" },
  { name: "MongoDB", icon: "database" }
];

